import { useTranslation } from 'react-i18next';
import { Brain, CheckCircle, Sparkles } from 'lucide-react';

const LandingRutiniAI = () => {
  const { t } = useTranslation();
  const bullets = [
    t('landing.rutiniAiBullet1'),
    t('landing.rutiniAiBullet2'),
    t('landing.rutiniAiBullet3'),
    t('landing.rutiniAiBullet4'),
  ];

  return (
    <section className="py-20 sm:py-28 px-4 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Text side */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-teal-500/30 bg-teal-500/10 px-4 py-1.5 text-xs font-semibold text-teal-600 dark:text-teal-400">
              <Sparkles className="h-3.5 w-3.5" />
              {t('landing.rutiniAiSubtitle')}
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold leading-tight">{t('landing.rutiniAiTitle')}</h2>
            <p className="text-muted-foreground leading-relaxed">{t('landing.rutiniAiDesc')}</p>
            <ul className="space-y-3">
              {bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle className="h-5 w-5 text-teal-500 mt-0.5 shrink-0" />
                  <span className="text-sm">{b}</span>
                </li>
              ))}
            </ul>
          </div>
          {/* Visual side */}
          <div className="flex items-center justify-center">
            <div className="relative w-64 h-64 sm:w-80 sm:h-80">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-teal-500/20 to-primary/20 blur-2xl" />
              <div className="relative w-full h-full rounded-3xl border border-teal-500/20 bg-card/80 backdrop-blur-sm flex flex-col items-center justify-center gap-4 p-8">
                <Brain className="h-16 w-16 text-teal-500 animate-float" />
                <p className="text-center text-sm font-semibold text-teal-600 dark:text-teal-400">Rutini AI</p>
                <div className="flex gap-2">
                  {['👦 5y', '👧 8y', '👦 12y'].map((label) => (
                    <span key={label} className="text-xs bg-muted rounded-full px-2 py-1">{label}</span>
                  ))}
                </div>
                <div className="w-full space-y-1.5">
                  {[60, 80, 50].map((w, i) => (
                    <div key={i} className="h-2 rounded-full bg-muted overflow-hidden">
                      <div className="h-full rounded-full bg-teal-500/60" style={{ width: `${w}%` }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingRutiniAI;
